import React from 'react';
import Contact1 from '../../components/ContactElements/Contact1';
import Contact2 from '../../components/ContactElements/Contact2';
import PageHeader from '../Shared/PageHeader';

const Contact01 = () => {
    return (
        <div>
            <PageHeader title="Contact Us" />
            <div className="main-wrapper">
                <div className="contact homestyle">
                    <Contact1 />
                    <Contact2 />
                </div>
            </div>

        </div>
    );
};

export default Contact01;